// @flow
import { connect } from 'react-redux';
import { omit } from 'lodash';

import ProductGallery from 'brastrap/promotional/product-gallery/ProductGallery';
import { getStickersFromAttributes } from 'brastrap/promotional/product-summary/ProductSummary';

import {
  setZoom,
  receiveImageDimensions,
  receiveThumbnailWidth,
} from '../../../actions/product';
import { APP_BREAKPOINTS } from '../../../constants/responsive';
import { saveItem } from '../../../actions/saved-items';
/**
 * Add video thumbnail to the images array
 *
 * @param {Object} obj - data object
 * @param {Array} obj.images
 * @param {Object} obj.video
 * @return {Array}
 */
const addVideoThumbnail = ({
  images = [],
  video,
}: {
  images: Array<Image>,
  video: Video,
}) => [
  ...images,
  {
    ...omit(video, '_type', 'title'),
    type: 'video',
  },
];

const mapStateToProps = ({
  app: { config, locale },
  product,
  browser: { deviceIs },
  savedItems: { itemMap },
}) => {
  const { data } = product.styleColour;
  const hasVideo = data.video && (data.video.iframe || data.video.src);

  const images = hasVideo ? addVideoThumbnail(data) : data.images;

  const video = hasVideo && data.video;

  return {
    breakpoints: APP_BREAKPOINTS,
    isDesktop: deviceIs.desktop,
    isTablet: deviceIs.tablet,
    isMobile: deviceIs.mobile,
    displayCarousel: product.displayGalleryCarousel,
    activeImageIndex: 0,
    figureDimensions: product.figureDimensions,
    images,
    isZoomed: product.isZoomed,
    productGalleryContainers: data.productGalleryContainers,
    stickers: getStickersFromAttributes(data.attributes, config.currency),
    video,
    product: data,
    selectedSku: product.styleColour.selectedSku,
    savedItemsMap: itemMap,
    locale: locale.selected,
    currency: config.currency,
  };
};

const mapDispatchToProps = dispatch => ({
  onFeaturedImageClick: () => dispatch(setZoom(true)),
  onZoomedImageClick: () => dispatch(setZoom(false)),
  getImageDimensions: dimensions =>
    dispatch(receiveImageDimensions(dimensions)),
  getThumbnailWidth: width => dispatch(receiveThumbnailWidth(width)),
  onSaveItemPress: item => dispatch(saveItem(item)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProductGallery);
